module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registration"
  }, [_c('navbar'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Regisztráció")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Profil készítése az orvosi felülethez")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\t\t\t\tEz a felület orvosok számára van fenntartva.\n\t\t\t\tA páciensek számára készítetett alkalmazás elérhető a Google Play és Apple App Store alkalmazásboltban."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Publikus adatok:")]), _vm._v(" A publikus adatokat a szoftverünket használó páciensek láthatják. Kizárólag a kék színnel jelzett mezők számítanak publikus információnak, minden más adatot kizárólag a regisztráció folyamatában használjuk a személyazonosság ellenőrzésére. A profil elfogadása utána további kapcsolati adatokat is megadhat a páciensei számára."), _c('br'), _vm._v(" "), _c('b', [_vm._v("Kötelező mezők:")]), _vm._v(" A csillaggal jelzett adatok megadása kötelező. Ezek alapján ellenőrizzük a személyazonosságát, és 24 órán belül elkészítjük a személyre szabott profilját."), _c('br'), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.registration($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("Alap adatok")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('md-input-container', [_c('label', {
    staticClass: "public"
  }, [_vm._v("Név (publikus)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('md-input-container', [_c('label', [_vm._v("E-mail cím")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('md-input-container', [_c('label', [_vm._v("Telefonszám")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.form.doctorData.phone),
      callback: function($$v) {
        _vm.$set(_vm.form.doctorData, "phone", $$v)
      },
      expression: "form.doctorData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('md-input-container', [_c('label', [_vm._v("Egészségügyi nyilvántartási szám")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.form.doctorData.healthcareId),
      callback: function($$v) {
        _vm.$set(_vm.form.doctorData, "healthcareId", $$v)
      },
      expression: "form.doctorData.healthcareId"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("Szakvizsga / szakvizsgák*")]), _vm._v(" "), _vm._l((_vm.form.doctorData.specialities), function(speciality) {
    return _c('div', {
      staticClass: "row"
    }, [_c('md-input-container', {
      staticClass: "col-md"
    }, [_c('label', [_vm._v("Szakvizsga megnevezése")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (speciality.name),
        callback: function($$v) {
          _vm.$set(speciality, "name", $$v)
        },
        expression: "speciality.name"
      }
    })], 1), _vm._v(" "), _c('md-button', {
      staticClass: "md-warn",
      on: {
        "click": function($event) {
          _vm.deleteElement(_vm.form.doctorData.specialities, speciality)
        }
      }
    }, [_vm._v("Törlés")])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "row end-xs"
  }, [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.form.doctorData.specialities.push({
          name: ''
        })
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tTovábbi szakvizsga hozzáadása\n\t\t\t\t\t\t\t")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "public"
  }, [_vm._v("Aktuális munkahely / munkahelyek (publikus)")]), _vm._v(" "), _vm._l((_vm.form.doctorData.workplaces), function(workplace) {
    return _c('div', {
      staticClass: "row"
    }, [_c('md-input-container', {
      staticClass: "col-md"
    }, [_c('label', [_vm._v("Munkahely neve")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (workplace.name),
        callback: function($$v) {
          _vm.$set(workplace, "name", $$v)
        },
        expression: "workplace.name"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md"
    }, [_c('label', [_vm._v("Osztály / szakrendelés")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (workplace.department),
        callback: function($$v) {
          _vm.$set(workplace, "department", $$v)
        },
        expression: "workplace.department"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md"
    }, [_c('label', [_vm._v("Beosztás")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (workplace.assignment),
        callback: function($$v) {
          _vm.$set(workplace, "assignment", $$v)
        },
        expression: "workplace.assignment"
      }
    })], 1), _vm._v(" "), _c('md-button', {
      staticClass: "md-warn",
      on: {
        "click": function($event) {
          _vm.deleteElement(_vm.form.doctorData.workplaces, workplace)
        }
      }
    }, [_vm._v("Törlés")])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "row end-xs"
  }, [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.form.doctorData.workplaces.push({
          name: '',
          department: '',
          assignment: ''
        })
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tTovábbi munkahely hozzáadása\n\t\t\t\t\t\t\t")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "public"
  }, [_vm._v("Egyéb adatok (nem kötelező)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('md-input-container', [_c('label', {
    staticClass: "public"
  }, [_vm._v("Jelenlegi weboldal (publikus)")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.doctorData.website),
      callback: function($$v) {
        _vm.$set(_vm.form.doctorData, "website", $$v)
      },
      expression: "form.doctorData.website"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('md-input-container', [_c('label', {
    staticClass: "public"
  }, [_vm._v("Facebook oldal (publikus)")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.doctorData.facebookPageUrl),
      callback: function($$v) {
        _vm.$set(_vm.form.doctorData, "facebookPageUrl", $$v)
      },
      expression: "form.doctorData.facebookPageUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('md-input-container', [_c('label', {
    staticClass: "public"
  }, [_vm._v("Foglalkozási kör (publikus)")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.doctorData.speciality),
      callback: function($$v) {
        _vm.$set(_vm.form.doctorData, "speciality", $$v)
      },
      expression: "form.doctorData.speciality"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row end-xs middle-xs"
  }, [_c('div', [_vm._v("\n\t\t\t\t\t\t\tA regisztrációval elfogadja az adatvédelmi nyilatkozatba foglalt feltételeinket:\n\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "../static/legal.pdf"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tnyilatkozat megtekintése\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tSikertelen regisztráció vagy hiba esetén keressen fel minket e-mailben:\n\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "mailto:hello@pulmoment.com?subject=Registration"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\thello@pulmoment.com\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    }
  }, [_vm._v("Küldés")])], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-460abe23!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegistrationView.vue
// module id = 416
// module chunks = 2